import { DEFAULT, LIBRARY } from '../../types';

export default (state, action) => {
    switch (action.type) {
        case DEFAULT.SET_LOADING:
            return {
                ...state,
                loading: true
            };
        case DEFAULT.SET_LOADING_FALSE:
            return {
                ...state,
                loading: false
            };
        case DEFAULT.RESET_MESSAGE:
            return {
                ...state,
                response: '',
                responseType: ''
            };
        case DEFAULT.SET_HAS_CHANGED:
            return {
                ...state,
                hasChanged: 0
            };
        case LIBRARY.GET_FINES:
            return {
                ...state,
                fines: action.payload
            };
        case LIBRARY.GET_FINES_TRANSACTIONS_DATA:
            return {
                ...state,
                finesTransactionsData: action.payload
            };
        case LIBRARY.CREATE_TRANSACTION:
            return {
                ...state,
                response: action.payload,
                responseType: action.responseType,
                successiveActions: action.successiveActions,
                hasChanged: action.hasChanged
            };
        case LIBRARY.GET_TRANSACTIONS:
            return {
                ...state,
                transactions: action.payload
            };
        default:
            return state;
    }
};
